var exports = {
  "z": "root__E4Qnsj",
  "v": "banner__HEtI_1",
};

module.exports = exports;
